import { AdaLocalizedDatePipe } from '@adaptiva/core/common';
import { IsRequiredPropertyPipe } from '@adaptiva/metadata/common';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { ComboComponentModule } from '@adaptiva/widgets/combo';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { ToggleSwitchComponent } from '@adaptiva/widgets/toggle-switch';
import { CommonModule } from '@angular/common';
import { NgModule, PipeTransform, Type } from '@angular/core';
import { HousekeepingPropertiesComponent } from './housekeeping-properties.component';

const WIDGETS: Type<any>[] = [
	CardComponentModule,
	ComboComponentModule,
	ContainerComponentModule,
	TextComponentModule,
	InputComponentModule,
	ToggleSwitchComponent,
];

const PIPES: Type<PipeTransform>[] = [
	IsRequiredPropertyPipe,
	AdaLocalizedDatePipe,
];

@NgModule({
	imports: [
		CommonModule,
		PIPES,
		WIDGETS
	],
	declarations: [HousekeepingPropertiesComponent],
	exports: [HousekeepingPropertiesComponent]
})
export class HousekeepingPropertiesComponentModule {

}
